export const POLICIES_QUERY = '/policies';
export const POLICY_TEMPLATES_QUERY = '/policy-templates';
export const POLICY_REVERT_TARGET_QUERY = '/policies/revert-target';
export const POLICY_APPLICABLE_SUPPLIERS_QUERY = '/policies/applicable-suppliers';
